export type TourKey = string;
export type ProgressPlacement = 'top' | 'before-footer' | 'after-footer';
export type PersistedState = { key: TourKey; stepIndex: number };

export type StepButton = {
  text: string;
  classes?: string;
  action?: (this: any, step?: any) => void; // 'this' bound to Shepherd Tour
};

export type TourStep = {
  id?: string;
  title?: string;
  skipOnResume?: boolean;
  text?: string | HTMLElement;
  attachTo?: { element: string | Element; on?: string };
  classes?: string;
  buttons?: StepButton[];
  scrollTo?: boolean | ScrollIntoViewOptions;
  when?: Record<string, (this: any) => void>;
  canClickTarget?: boolean;
  arrow?: boolean;
  highlightClass?: string;
  modalOverlayOpeningPadding?: number;
  modalOverlayOpeningRadius?: number;
  beforeShowPromise?: () => Promise<unknown>;
  popperOptions?: Partial<unknown>;
};

export type TourRuntimeOptions = {
  progress?: boolean; // default: true
  progressPlacement?: ProgressPlacement; // default: 'after-footer'
  defaultStepOptions?: Partial<TourStep>;
};

export type TourBuilder = {
  key: TourKey;
  buildSteps(): TourStep[];
  defaults?: Partial<TourStep>;
};
